import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Constants } from 'src/app/domain/const/constants';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EventsService {

    constructor(private http: HttpClient) { }


    GetEventImages(EventId: number, access_token: string) {



        const params = new HttpParams()
            .set(Constants.EVENT_ID, EventId.toString())

        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + access_token,
        });



        return this.http.get<any>(`${environment.urlStorageApi}${Constants.EVENT_IMAGES}`, { params: params, headers: headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )




        // const params = new HttpParams()
        //     .set(Constants.EVENT_ID, EventId)


        //     let new_acces_token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6InoxcnNZSEhKOS04bWdndDRIc1p1OEJLa0JQdyIsImtpZCI6InoxcnNZSEhKOS04bWdndDRIc1p1OEJLa0JQdyJ9.eyJhdWQiOiJhcGk6Ly9iYTQ4NGFiZC0zNjhhLTRlMjUtYjFkYS1iZjA1MjExOThiNTAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC9iNDA0MDg0Mi05ZTlmLTQzMDAtOThmMy1jMTNmZTFhNjdmZDIvIiwiaWF0IjoxNzM3MDgxNzQyLCJuYmYiOjE3MzcwODE3NDIsImV4cCI6MTczNzA4NTY0MiwiYWlvIjoiazJSZ1lJZzlZK00rYlZQVFJTSHVmUTYxL01ZaUFBPT0iLCJhcHBpZCI6IjYxMjJmNDM0LWIzYzktNGExMS04MGMyLTAwOTJkMDUyNTdlOSIsImFwcGlkYWNyIjoiMSIsImlkcCI6Imh0dHBzOi8vc3RzLndpbmRvd3MubmV0L2I0MDQwODQyLTllOWYtNDMwMC05OGYzLWMxM2ZlMWE2N2ZkMi8iLCJvaWQiOiIzYWI0MTI0OC0xODFmLTQ0MDEtYTgxMS0yNDQzMTIzMWM3MTUiLCJyaCI6IjEuQVgwQVFnZ0V0Si1lQUVPWTg4RV80YVpfMHIxS1NMcUtOaVZPc2RxX0JTRVppMUI5QUFCOUFBLiIsInJvbGVzIjpbIklSX1dSSVRFX1FBIl0sInN1YiI6IjNhYjQxMjQ4LTE4MWYtNDQwMS1hODExLTI0NDMxMjMxYzcxNSIsInRpZCI6ImI0MDQwODQyLTllOWYtNDMwMC05OGYzLWMxM2ZlMWE2N2ZkMiIsInV0aSI6IkU0TGJYV1JLVWtLT3lyamJqMGlRQUEiLCJ2ZXIiOiIxLjAifQ.YQR8IgEeGs62BeTmuXi8puG6JhRqbu5M9Jb2446V8e9qoV31HzWOQtgoGyEOMVXnLhTmUScCuCA1CWHVm0d4MaGFRr7M6j9mHuOSo_7GWnMJ9ho0RrWKTj34A-ogJPw7XxgqTqdoCGGCQG5528cX5RYpJcy8h4q-e7pZB40gY5MBX6zhbVFayZ929UnDbEZ92CypSQunAYjLlqfyYln3X1aB6tPKXnh2TxAhfVLY_nVWh6cMR8NoqZqkAxf2RUrPBvctdEmPVUKGKg7qxdUeKYV45kdKYnfa86IEqrC2sQE2PpRLPHJolkFAWiHViMn5X5yx7gUkXDSG0xuQJn-tqQ'


        //     const headers = new HttpHeaders({
        //         'Authorization': `Bearer ${new_acces_token}`
        //     });
        // return this.http.get<any>(`${environment.urlStorageApi}${Constants.EVENT_IMAGES}`, { params: params })
        //     .pipe(
        //         catchError((error: HttpErrorResponse) => {
        //             let mensajeError = 'an error occurred while getting the data.';
        //             if (error.status === 404) {
        //                 mensajeError = 'The requested resource was not found.';
        //             }
        //             return throwError(() => new Error(mensajeError));
        //         })
        //     )
    }


    GetEventsFileNames(eventsIds: any, access_token: string) {
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + access_token,
            'content-type': 'application/json'
        });

        const body = JSON.stringify(eventsIds);

        return this.http.post(`${environment.urlStorageApi}${Constants.GET_EVENTS_FILE_NAMES}`, body, { 'headers': headers })
    }

   

     StreamingBlob(file: string, access_token: string): Observable<Blob> {
        

        let encodingFile = encodeURIComponent(file);

        // const params = new HttpParams()
        //     .set(Constants.FILE, encodingFile)

        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + access_token,
        });

        return this.http.get(`${environment.urlStorageApi}${Constants.STREAMING_BLOB}?file=${file}`, {
            headers: headers,
            responseType: 'blob'
        });

        // return this.http.get(`${environment.urlStorageApi}${Constants.STREAMING_BLOB}`, { params: params, headers: headers })
     }
}
